import type { AccountRole, AccountTier } from "@/lib/nav/account-menu";
import { DEFAULT_LOCATION_SLUG } from "@/lib/constants";

export type ChromeState = {
  isSignedIn: boolean;
  isAdmin: boolean;
  displayName: string | null;
  email: string | null;
  savedCampCount: number;
  premium: boolean;
  isProvider: boolean;
  locationSlug: string;
  locationName: string;
};

export const DEFAULT_CHROME_STATE: ChromeState = {
  isSignedIn: false,
  isAdmin: false,
  displayName: null,
  email: null,
  savedCampCount: 0,
  premium: false,
  isProvider: false,
  locationSlug: DEFAULT_LOCATION_SLUG,
  locationName: "Bend, Oregon",
};

export const NON_LOCATION_PREFIXES = new Set([
  "about",
  "account",
  "account-delete",
  "activity-camps",
  "admin",
  "alerts",
  "auth",
  "blog",
  "camps",
  "changelog",
  "explore",
  "friends",
  "guides",
  "help",
  "home",
  "kids",
  "locations",
  "my-family",
  "my-reviews",
  "api",
  "p",
  "panel",
  "planner",
  "plans",
  "pricing",
  "privacy",
  "providers",
  "reset-password",
  "reviews",
  "saved",
  "share",
  "sign-in",
  "sign-out",
  "submit-camp",
  "summer-camp-planner",
  "terms",
  "thanks",
  "trust",
  "welcome",
]);

export function hideGlobalChrome(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/providers/dashboard") ||
    pathname.startsWith("/providers/preview") ||
    pathname.startsWith("/providers/review") ||
    pathname.startsWith("/providers/new")
  );
}

export function locationSlugFromPath(pathname: string): string | null {
  const locationMatch = pathname.match(/^\/([a-z0-9-]+)(?:\/|$)/);
  if (!locationMatch || NON_LOCATION_PREFIXES.has(locationMatch[1])) {
    return null;
  }
  return locationMatch[1];
}

export function accountTierForChrome(state: ChromeState): AccountTier {
  if (!state.isSignedIn) return "anonymous";
  return state.premium ? "premium" : "free";
}

export function accountRoleForChrome(state: ChromeState): AccountRole {
  if (!state.isSignedIn) return "anonymous";
  return state.isAdmin ? "admin" : "parent";
}
